<template>
    <div class="page bg-gray page-flex">
        <appStatus :statusHeight="statusHeight"></appStatus>
        <div class="page-input-title" :style="{top:statusHeight+'rem'}">
            <div class="alifont icon-back left-icon click" @click="back"></div>
            <input type="search" @keyup.13="handleQuery" class="center-input fs-28" placeholder="搜索小区名"
                   v-model="pageInfo.orgName">
            <div class="right fs-28 color-333 click" @click="handleQuery">
                搜索
            </div>
        </div>
        <div class="flex1 posi-rel pd-025 pb-25">
            <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
                <div class="card mt-20" v-for="(item,$index) in data" :key="$index">
                    <div class="flex-center pd-25 fs-32 bd-bot font-bold">
                        <div class="flex1 mr-20 color-333">{{item.orgName}}</div>
                        <div class="color-org" v-show="item.spaceNum != 0">{{item.spaceNum || 0}}空格</div>
                        <div class="color-warning" v-show="item.spaceNum == 0">已满</div>
                    </div>
                    <div class="pd-25">
                        <div class="flex-between fs-28">
                            <div class="flex1 mr-20 color-333">寄存柜数：{{item.shopNum || 0}}</div>
                            <div class="color-main font-bold">待配送：{{item.waitShipOrder || 0}}</div>
                        </div>
                        <div class="mt-30 flex">
                            <div class="btn mr-25 flex1 click" @click="$router.push({name:'lockerOrderList',query:{orgName:item.orgName,orgId:item.orgId}})">全部订单</div>
                            <div class="btn flex1 click" @click="$router.push({name:'lockerHouseDetail',query:{orgName:item.orgName,orgId:item.orgId}})">寄存详情</div>
                        </div>
                    </div>
                </div>
            </scroller>
        </div>
    </div>
</template>

<script>
    import initData from "@/mixins/initData"
    import routerBack from "@/mixins/routerBack"
    import appStatus from "@/components/appStatus/index"
    import getAppStatusHeight from "@/mixins/getAppStatusHeight";
    export default {
        name: "lockerHouseList",
        mixins: [initData, routerBack, getAppStatusHeight],
        components: {appStatus},
        data(){
            return{

            }
        },
        methods:{
            back() {
                if (this.isBackClose) {
                    try {
                        window.native.onFinish();
                    } catch (e) {

                    }
                } else {
                    try {
                        window.native.onBack();
                    } catch (e) {
                        this.$router.go(-1)
                    }
                }
            },
            beforeInit() {
                this.params = {page: this.page, limit: this.limit};
                this.url = 'shop/shopZoneWay/qryOrgWayUseInfo';
                let query = this.pageInfo;
                for (var key in query) {
                    if (query[key]) {
                        this.params[key] = query[key]
                    }
                }
                return true
            },
        },
        beforeRouteEnter(to, from, next) {
            if (from.name == "lockerOrderList" || from.name == "lockerHouseDetail") {
                to.meta.isBack = true;
            } else {
                to.meta.isBack = false;
            }
            next();
        },
        activated() {
            if (!this.$route.meta.isBack) {
                if(this.hasAlive){
                    this.handleQuery();
                }
            }
            this.$route.meta.isBack = false;
        },
    }
</script>

<style scoped lang="scss">
    .btn{
        height: .72rem;
        line-height: .72rem;
        text-align: center;
        background: #F5F5F5;
        border-radius: .08rem;
        font-size: .28rem;
        color: #333;
    }
</style>



// WEBPACK FOOTER //
// lockerHouseList.vue?17d5ccd7